import { renderWidget } from './ui';

(async function () {
  const script = document.currentScript as HTMLScriptElement | null;
  if (!script) return;
  const tenantSlug = script.dataset.tenant;
  if (!tenantSlug) { console.error('[chatbot] data-tenant required'); return; }
  const color = script.dataset.color ?? '#2D6A4F';
  const position = script.dataset.position ?? 'bottom-right';
  const apiBase = (script.dataset.api ?? script.src.replace(/\/widget\.js.*$/, '')) || '';
  const mode = (script.dataset.mode === 'inline' ? 'inline' : 'fixed') as 'fixed' | 'inline';
  // 런처를 접을 수 있게 할지. 어드민 콘솔처럼 위젯이 **화면 내용을 가리는 곳**에서만 켠다.
  // 손님 사이트에서는 켜지 않는다 — 이 버튼이 예약 문의의 입구다.
  const collapsible = script.dataset.collapsible === '1' || script.dataset.collapsible === 'true';
  // 어드민 '데이터 질의' 브리지. 켜져 있어도 위젯은 인증을 다루지 않는다 — 어드민 페이지가
  // 등록한 window.__staytoqAdminAsk 훅을 부를 뿐이고, 손님 사이트엔 그 훅이 없다(건너뜀).
  const adminBridge = script.dataset.adminBridge === '1';
  // 페이지의 말(data-lang) — 다국어 홈페이지가 /en·/ja·/zh 화면에서 넣는다. 그 화면에선 위젯도 그 말로 연다(ui.ts).
  const pageLang = script.dataset.lang;
  let targetEl: HTMLElement | null = null;
  if (mode === 'inline') {
    const sel = script.dataset.target;
    targetEl = sel
      ? (document.querySelector(sel) as HTMLElement | null)
      : (script.previousElementSibling as HTMLElement | null);
    if (!targetEl) {
      console.error('[chatbot] inline mode requires data-target or a previous sibling');
      return;
    }
  }
  await renderWidget({ tenantSlug, color, position, apiBase, mode, targetEl, collapsible, adminBridge, pageLang });
})();
